const P_BEHAV_APPLY = function(content) {BEHAV.apply(content)};
global.iconViewDefaultSettings = {
    "icon" : {
        "path" : "",
        "extention" : "<?=opt('icon.set_type')?>"
    },
    "parent" : {
        "label" : '..',
        "icon" : 'arrow-do-undo'
    },
    "root" : {
        "label" : 'Racine',
        "icon" : 'place-home'
    },
    "none" : {
        "label" : 'Vide',
        "icon" : 'status-warning'
    },
    "default": {
        "icon": 'page',
    },
    "events" : {
        "render" : P_BEHAV_APPLY,
        "error" : function(data) {
            if (typeof data == 'object') data = data.message
            msg('error', data)
        }
    },
    "refresh" : opt('iv.refresh_auto')
};

global.refreshIv = function(target) {
    target.find('.iv').each(function() {
        if ($(this).data('plugin')) $(this).data('plugin').resize();
    })
}